import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { makeRequest } from "../assets/functions_helper";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function TransferFlow() {
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [paymentUrl, setPaymentUrl] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hashParams = new URLSearchParams(location.hash.substring(1));
    const challenge = params.get("challenge") || hashParams.get("challenge");
    const redirectUri = params.get("redirect_uri") || hashParams.get("redirect_uri");
    const planId = params.get("plan_id") || hashParams.get("plan_id");
    const upgradeMode = (params.get("upgrade_mode") || hashParams.get("upgrade_mode")) === "true";
    const paymentMethod = params.get("payment_method") || hashParams.get("payment_method") || "CARD";

    if (!challenge || !redirectUri) {
      setError("Faltan parámetros requeridos para la transferencia.");
      return;
    }

    const generateToken = async () => {
      try {
        const token = localStorage.getItem("token");
        const tokenType = localStorage.getItem("tokenType");

        if (!token) {
          navigate("/login", { state: { from: location.pathname + location.search } });
          return;
        }

        const dataToPass = {
          plan_id: planId,
          upgrade_mode: upgradeMode,
          payment_method: paymentMethod,
          token: token,
          tokenType: tokenType
        };

        const res = await makeRequest(
          "POST",
          "users/generate-transfer-token",
          {
            challenge: challenge,
            data: dataToPass,
          },
          "application/json",
          token,
          tokenType,
          () => navigate("/login")
        );

      const transferToken = res.token;
      if (!transferToken) throw new Error("No se recibió token de transferencia");

      // Build redirect URL
      const url = new URL(redirectUri);
      url.hash = `transfer_token=${transferToken}`;
      const finalUrl = url.toString();

      setPaymentUrl(finalUrl);
      
      // Try to open automatically
      window.open(finalUrl, "_blank");

    } catch (err) {
      console.error("Error al generar transfer token:", err);
      setError("Error al autorizar el pago. Por favor intenta nuevamente.");
    }
  };

  generateToken();
}, [location, navigate]);

  if (error) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <Typography color="error" variant="h6">
          {error}
        </Typography>
      </Box>
    );
  }

  if (paymentUrl) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          gap: 2,
          p: 3,
          textAlign: "center"
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          Continúa en la nueva pestaña
        </Typography>
        <Typography color="text.secondary">
          Hemos abierto una ventana segura para procesar tu pago. Una vez finalices, esta pantalla se actualizará.
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          ¿No se abrió la pestaña? 
          <a href={paymentUrl} target="_blank" rel="noopener noreferrer" style={{ marginLeft: "5px", color: "#f72e41", fontWeight: "bold", textDecoration: "none" }}>
            Haz clic aquí para ir al pago
          </a>
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography>Preparando entorno seguro de pago...</Typography>
    </Box>
  );
}
